import type { ReleaseNotesEntry } from './interfaces/release-notes-entry.interface';
import { currentVersion, parseReleaseNotes } from './release-notes.parser';

/**
 * Parses the bundled release notes without ever throwing.
 *
 * A malformed file must not stop the app: on a parse error this logs once and answers no entries and
 * no version, so the settings menu shows the entry without a number and the dialog its empty state.
 * The file guard test parses the real file directly, so a broken file still fails the build's tests.
 */
export function loadReleaseNotes(raw: string): { entries: readonly ReleaseNotesEntry[]; version: string | null } {
    try {
        const entries = parseReleaseNotes(raw);
        return { entries, version: currentVersion(entries) };
    } catch (error) {
        console.error('Release notes could not be parsed', error);
        return { entries: [], version: null };
    }
}
